import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import useFetch from "@/hook/useFetch/useFetch";
import { getBenefitAllocations } from '@/services/benefits/benefit';
import { SpaceshipLoader } from '@/components/spaceship-loader/spaceship-loader';
import BenefitDetails from './components/benefit-details.tsx/benefit-details';
import { PageContainer } from './style-component';
import { useUserContext } from '@/contexts/user/useUserContext';
import SEOHelmet from '@/components/SEOHelmet/SEOHelmet';
import { amplitudeAddTrack, determineProjectName } from '@/utils/amplitud/event-track';

const REFETCH_TIMEOUT = 60000;

const BenefitPage: React.FC = () => {
  const { contract_address, contract_type_id } = useParams<{ contract_address: string, contract_type_id: string }>();

  const { user } = useUserContext();

  const { data: benefit, loading, error, startFetch } = useFetch(getBenefitAllocations, { contract_address: contract_address ?? '', contract_type_id: contract_type_id ?? '', user_main_key: user?.main_key ?? '', limit: 1 });

  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {

    //Refetch benefit with Interval
    intervalRef.current = setInterval(() => {
      startFetch();
    }, REFETCH_TIMEOUT);

    return () => {
      // Clear interval when component unmounts
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [startFetch])

  const firstRenderAmplitude = useRef<boolean>(true);
  useEffect(() => {
    if (!loading && !error && firstRenderAmplitude.current) {
      firstRenderAmplitude.current = false;
      amplitudeAddTrack(determineProjectName(`Beneficio`), {
        title: determineProjectName(`Beneficio`),
      })
    }
  }, [error, loading]);

  if (error) return <div style={{ color: 'white' }}>¡Beneficio no encontrado!</div>;

  return (
    <PageContainer>
      <SEOHelmet
        metadata={{
          title: determineProjectName(`Beneficio`),
          description: determineProjectName(`Beneficio`)
        }}
      />
      <BenefitDetails benefit={benefit?.[0] || []} loading={loading}>
        {loading && <SpaceshipLoader height="300px" />}
      </BenefitDetails>
    </PageContainer>
  );
};

export default BenefitPage;